const METRIC_PERFORMANCE_WINDOW_KEY = 'metricsPerformanceInLifecycle';

export enum MetricPerformanceKey {
  METRIC_LIFECYCLE_START = 'metrics-lifecycle-start',
  /**
   * ./metricsLifecyclePrefetch ViewRoute 入口加载开始时间点
   */
  METRIC_LIFECYCLE_VIEW_ROUTE_START = 'metrics-lifecycle-view-route-start',
  METRIC_LIFECYCLE_PREFETCH_START_SYNC = 'metrics-lifecycle-prefetch-start-sync',
  METRIC_LIFECYCLE_PREFETCH_START = 'metrics-lifecycle-prefetch-start',
  /**
   * ./metricsLifecyclePrefetch 副作用执行时间点
   */
  METRIC_LIFECYCLE_PREFETCH_ASYNC_RESOURCE_SIDE_EFFECT_START = 'metrics-lifecycle-prefetch-async-resource-side-effect-start',
  /**
   * ./metricsLifecyclePrefetch 异步资源加载结束（import then）时间点
   */
  METRIC_LIFECYCLE_PREFETCH_ASYNC_RESOURCE_LOAD_END = 'metrics-lifecycle-prefetch-async-resource-load-end',
  /**
   * ./metricsLifecyclePrefetch 异步资源加载结束（ViewRoute 入口 import then）时间点
   */
  METRIC_LIFECYCLE_PREFETCH_ASYNC_RESOURCE_VIEW_ROUTE_LOAD_END = 'metrics-lifecycle-prefetch-async-resource-view-route-load-end',
  /**
   * ./metricsLifecyclePrefetch 中 LaunchModuleLifecycleContribution onStart 开始执行时间点
   */
  METRIC_LIFECYCLE_PREFETCH_ASYNC_RESOURCE_START = 'metrics-lifecycle-prefetch-async-resource-start',
  METRIC_LIFECYCLE_PREFETCH_PROJECT_KEY_COST = 'metrics-lifecycle-prefetch-project-key-cost',
  METRIC_LIFECYCLE_PREFETCH_DATA_COST = 'metrics-lifecycle-prefetch-data-cost',
  METRIC_LIFECYCLE_PREFETCH_ASYNC_LAYOUT_DATA_COST = 'metrics-lifecycle-prefetch-async-layout-data-cost',
  METRIC_LIFECYCLE_PREFETCH_SYNC_LAYOUT_DATA_COST = 'metrics-lifecycle-prefetch-sync-layout-data-cost',
  METRIC_LIFECYCLE_PREFETCH_STORAGE_CHART_DATA_START = 'metrics-lifecycle-prefetch-storage-chart-data-start',
  METRIC_LIFECYCLE_PREFETCH_STORAGE_CHART_DATA_COUNT = 'metrics-lifecycle-prefetch-storage-chart-data-count',
  METRIC_LIFECYCLE_PREFETCH_CHART_DATA_START = 'metrics-lifecycle-prefetch-chart-data-start',
  METRIC_LIFECYCLE_PREFETCH_CHART_DATA_COUNT = 'metrics-lifecycle-prefetch-chart-data-count',
  METRIC_LIFECYCLE_PREFETCH_RESOURCE_COST = 'metrics-lifecycle-prefetch-resource-cost',
}

export enum MetricTagKey {
  METRIC_LIFECYCLE_PREFETCH_LAYOUT_DATA_TYPE = 'metrics-lifecycle-prefetch-layout-data-type',
  /** ./metricsLifecyclePrefetch 最快引入来源 */
  METRIC_LIFECYCLE_INVOKE_SOURCE = 'metrics-lifecycle-invoke-source',
}

export enum InvokeSource {
  /** 基座：packages/project_manager_fe/src/index.ts */
  BASE = 'base',
  /** ViewRoute 外层：packages/platform/config/router/base.config.tsx */
  VIEW_ROUTE = 'view-route',
}

class MetricPerformanceRecord {
  constructor() {
    this.initRecord();
  }

  initRecord() {
    if (!window[METRIC_PERFORMANCE_WINDOW_KEY]) {
      window[METRIC_PERFORMANCE_WINDOW_KEY] = {
        performance: {},
        tag: {},
      };
    }
  }

  recordPerformance(key: MetricPerformanceKey, timestamp: number) {
    this.initRecord();
    if (window[METRIC_PERFORMANCE_WINDOW_KEY].performance[key] === undefined) {
      window[METRIC_PERFORMANCE_WINDOW_KEY].performance[key] = timestamp;
    }
  }

  recordTag(key: MetricTagKey, value: string) {
    this.initRecord();
    if (window[METRIC_PERFORMANCE_WINDOW_KEY].tag[key] === undefined) {
      window[METRIC_PERFORMANCE_WINDOW_KEY].tag[key] = value;
    }
  }

  clear() {
    window[METRIC_PERFORMANCE_WINDOW_KEY] = undefined;
  }
}

const metricPerformanceRecord = new MetricPerformanceRecord();

export { metricPerformanceRecord };
